import type { ReactNode } from 'react';

import { LuChevronDown } from 'react-icons/lu';

interface CollapsibleEmailSectionProps {
  isOpen: boolean;
  onToggle: () => void;
  toggleLabel: string;
  dividerLabel: string;
  children: ReactNode;
}

const stylesheet = {
  toggle:
    'mt-[22px] flex w-full items-center justify-center gap-[7px] text-semantic-text-secondary font-semibold hover:text-semantic-text-primary text-[15px] transition-colors',
  chevronOpen: 'transition-transform duration-200 rotate-180',
  chevronClosed: 'transition-transform duration-200',
  collapsible: 'grid transition-[grid-template-rows,opacity] duration-300 ease',
  collapsibleOpen: 'grid-rows-[1fr] opacity-100 mt-4',
  collapsibleClosed: 'grid-rows-[0fr] opacity-0 mt-0',
  inner: 'overflow-hidden',
  divider:
    'flex items-center gap-[14px] text-semantic-text-tertiary text-[13px] mb-[18px]',
  dividerLine: 'flex-1 h-px bg-semantic-border',
};

export function CollapsibleEmailSection({
  isOpen,
  onToggle,
  toggleLabel,
  dividerLabel,
  children,
}: Readonly<CollapsibleEmailSectionProps>): ReactNode {
  return (
    <>
      <button
        type="button"
        className={stylesheet.toggle}
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span>{toggleLabel}</span>
        <LuChevronDown
          className={isOpen ? stylesheet.chevronOpen : stylesheet.chevronClosed}
        />
      </button>
      <div
        className={`${stylesheet.collapsible} ${
          isOpen ? stylesheet.collapsibleOpen : stylesheet.collapsibleClosed
        }`}
      >
        <div className={stylesheet.inner}>
          <div className={stylesheet.divider}>
            <span className={stylesheet.dividerLine} />
            <span>{dividerLabel}</span>
            <span className={stylesheet.dividerLine} />
          </div>
          {children}
        </div>
      </div>
    </>
  );
}
